import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Link } from 'react-router-dom';
import { API_URL } from '..';
import swal from 'sweetalert';

window.JSZip = jszip;
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const CompanyJobTable = ({ jobsData }) => {
  const history = useNavigate();

  const handleDelete = async (id) => {
    swal({
      title: 'Are you sure you want to delete this job?',
      text: 'This action cannot be undone!',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        let response = await fetch(`${API_URL}/api/job/affiliate/delete-single/${id}`, { 
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
        });
        let data = await response.json();
        if (data.message === 'success') {
          window.location.reload();
        }
      }
    });
  };

  useEffect(() => {
    const table = $('#dataTable').DataTable({
      data: jobsData,
      responsive: true,
      pageLength: 10,
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
      columns: [
        { data: 'id' },
        { data: 'fullname' },
        { data: 'phone' },
        { data: 'driver.first_name', render: (data,type,row) => `<span>${data + ' '+row?.driver?.last_name || 'N/A'}</span>` },
        { data: 'affiliate.business_name' },
        { 
          data: 'status', 
          render: (data, type, row) => `<span>${data === 'new' && row.status_for_job === 'New Call' ? 'In-Queue' : row.status_for_job}</span>` 
        },
        {
          data: null,
          render: (data, type, row) => {
            if(row.tracking_status === true){
              return(
                `
            <div class="dropdown">
              <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="ph ph-list"></i>
              </button>
              <ul class="dropdown-menu">
                <li><a style="cursor:pointer" class="dropdown-item view-tracking" data-id="${row.id}"><i class="ph ph-file-text"></i> Live Tracking</a></li>
                <li><a style="cursor:pointer" class="dropdown-item view-invoice" data-id="${row?.invoices[0]?.id}"><i class="ph ph-file-text"></i> View Invoice</a></li>
                <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Job</a></li>
                <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Job</a></li>
                <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Job</a></li>
              </ul>
            </div>
          `
              );
            }else{
                return (
                  `
            <div class="dropdown">
              <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="ph ph-list"></i>
              </button>
              <ul class="dropdown-menu">
                
                <li><a style="cursor:pointer" class="dropdown-item view-invoice" data-id="${row?.invoices[0]?.id}"><i class="ph ph-file-text"></i> View Invoice</a></li>
                <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Job</a></li>
                <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Job</a></li>
                <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Job</a></li>
              </ul>
            </div>
          `
                );
            }
          },
          title: 'Actions',
          orderable: false,
        },
      ],
    });

    $('#dataTable tbody').on('click', '.edit-btn', function () {
      history(`/lead-edit/${$(this).data('id')}`);
    });
    $('#dataTable tbody').on('click', '.view-tracking', function () {
      // console.log($(this).data('id'))
      history(`/live-tracking/${$(this).data('id')}`);
    });
    $('#dataTable tbody').on('click', '.view-invoice', function () {
      const jobId = $(this).closest('tr').find('.view-btn').data('id'); // Get the job ID
      const invoiceId = $(this).data('id');
    
      if (invoiceId === undefined || invoiceId === 'undefined') {
        swal({
          title: 'No Invoice Found',
          text: 'No invoice has been created for this job. Would you like to create one?',
          icon: 'error',
          buttons: {
            cancel: {
              text: 'Cancel',
              value: false,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Create Invoice',
              value: true,
              visible: true,
              className: 'btn-success', // Optional: adds styling to the button
              closeModal: true
            }
          }
        }).then((willCreate) => {
          if (willCreate) {
            history(`/create-invoice/${jobId}`);
          }
        });
        return false;
      } else {
        history(`/view-invoice/${invoiceId}`);
      }
    });
    $('#dataTable tbody').on('click', '.view-btn', function () {
        history(`/lead-view/${$(this).data('id')}`);
    });
    $('#dataTable tbody').on('click', '.delete-btn', function () {
      handleDelete($(this).data('id'));
    });

    return () => {
      table.destroy(true);
    };
  }, [jobsData]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Jobs</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info ms-2" to={'/add-lead'}>Add New</Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable">
          <thead>
            <tr>
              <th>ID</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Assigned To</th>
              <th>Assigned By</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  );
};

export default CompanyJobTable;